import type { CSSProperties } from 'react';

export const HERO_BACKGROUND_ANIMATION_COMPLETE_EVENT = 'animation_complete';
export const HERO_BACKGROUND_ANIMATION_START_EVENT = 'animation_start';

export interface HeroBackgroundPrismConfig {
  animationType: 'rotate';
  timeScale: number;
  height: number;
  baseWidth: number;
  scale: number;
  hueShift: number;
  colorFrequency: number;
  noise: number;
  glow: number;
  maxDpr: number;
  scrollMaxScale: number;
  scrollMaxGlow: number;
  scrollRangePx: number;
}

export const HERO_BACKGROUND_PRISM_DESKTOP: HeroBackgroundPrismConfig = {
  animationType: 'rotate',
  timeScale: 0.4,
  height: 2,
  baseWidth: 3,
  scale: 4,
  hueShift: 0.4,
  colorFrequency: -1.2,
  noise: 0,
  glow: 0.35,
  maxDpr: 2,
  scrollMaxScale: 10,
  scrollMaxGlow: 1.3,
  scrollRangePx: 600,
};

export const HERO_BACKGROUND_PRISM_MOBILE: HeroBackgroundPrismConfig = {
  animationType: 'rotate',
  timeScale: 0.3,
  height: 3,
  baseWidth: 4,
  scale: 1.5,
  hueShift: 0.3,
  colorFrequency: -1.2,
  noise: 0,
  glow: 0.2,
  maxDpr: 1.5,
  scrollMaxScale: 10,
  scrollMaxGlow: 1.3,
  scrollRangePx: 600,
};

export const HERO_BACKGROUND_ENTRY_DURATION_SEC = 2.5;
// entryProgress (0->1) is treated as "entrance done" past this, so the entrance ramp's
// deliberate scale/glow changes aren't judged as bad frames by the health gate.
export const HERO_BACKGROUND_ENTRANCE_COMPLETE_THRESHOLD = 0.99;
export const HERO_BACKGROUND_WEBGL_FAILURE_LABEL =
  '[Cherobackground] WebGL unavailable; using static background.';

// Static, no-WebGL/no-canvas/no-filter hero background. The universal fallback whenever the
// animated Prism can't run smoothly - WebGL failure/context-loss, a browser-reported major
// performance caveat, prefers-reduced-motion, or sustained low FPS (see usePrismHealthGate).
// It's a single static paint, so it costs nothing per frame.
export const STATIC_HERO_BACKGROUND_STYLE: CSSProperties = {
  position: 'absolute',
  inset: 0,
  backgroundImage: 'radial-gradient(120% 90% at 50% 0%, rgb(0, 43, 31) 0%, rgb(0, 12, 30) 55%, rgb(0, 0, 0) 100%)',
};
